'use client'

import { productionUrl } from '@/app/util/env'
import { cn } from '@/util/cn'
import Navigation from '../navigation'
import Video from '../video'
import Typography from '@/app/components/typography'
import BackgroundAnimationLayout from '../background-animation-layout'

const Header = () => (
    <BackgroundAnimationLayout>
        <Navigation className="mb-[2.9rem]" />

        <div className="relative text-giphyLightGrey grid place-content-center px-3">
            <img
                src={`${productionUrl}/static/img/about/stickers/logo-spin.gif`}
                className="block w-auto mx-auto h-[9.625rem]"
                alt=""
            />
            
            <Typography variant="text-lg" fontWeight="bold" className="inline-block mx-auto bg-linear-to-r from-giphyIndigo to-giphyBlue bg-clip-text text-transparent text-center mb-[1.375rem]" as="h2">
                Animated Search Engine
            </Typography>
            
            <Typography variant="h1" as="h1" fontFamily="nexaBlack" className="mx-auto text-center mb-[1.125rem]" fontWeight="bold">
                GIPHY is the platform that animates your world.
            </Typography>
            
            <Typography variant="text-xl" className="text-center max-w-(--content-max-width) mx-auto">
                GIPHY is not just GIFs... we are Stickers, Clips, and much more. Every day, we are serving{' '}
                <strong className="text-giphyWhite font-bold underline">10+&nbsp;billion</strong> pieces of GIPHY
                content to a daily user reach of{' '}
                <strong className="text-giphyWhite font-bold underline">1+&nbsp;billion</strong> people, helping
                them express themselves and make their everyday conversations more entertaining.
            </Typography>
            
            <div className="z-10 aspect-[16/9] max-w-(--content-max-width) w-full mx-auto">
                <Video classNames={{
                    videoWrapper: cn('translate-y-[8.25rem]'),
                    overlayWrapper: cn('max-w-(--page-max-width)')
                }} />
            </div>
        </div>
    </BackgroundAnimationLayout>
)

export default Header
